<!-- <div class="page-container">
  <div class="top-bar">
    <button class="btn btn-primary" (click)="addOrder()">Add Order</button>
  </div>

  <div class="">
    <div class="order-card mt-4" *ngFor="let order of orders">
      <div class="card-header">
        <div class="user-avatar d-flex justify-content-between gap-2 align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <div class="d-flex flex-column">
            <div class="font-white fs-18 fw-semibold">{{ order.name }}</div>
            <div class="fs-14">{{ order.email }}</div>

            <div class="fs-14">{{ order.mobile }}</div>
          </div>
        </div>
        <div class="header-meta">
          <div class="status-badge" [class.pending]="order.status === 'PENDING'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>{{ order.status }}</span>
          </div>
          <div class="date-badge">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            <span>{{ order.date }}</span>
          </div>
        </div>
      </div>

      <div class="info-section">
        <label>Address:</label>
        <div class="info-content">{{ order.address }}</div>
      </div>

      <div class="info-section">
        <label>Ordered Items:</label>
        <div class="items-box">
          <div class="item-row" *ngFor="let item of order.items">
            <div class="item-details">
              <div class="item-name">{{ item.name }} - {{ item.details }}</div>
              <div class="item-stock">Stock: {{ item.stock }} available</div>
            </div>
            <div class="item-price">${{ item.price }}</div>
          </div>
          <div class="divider"></div>
          <div class="total-row">
            <span class="total-label">Total:</span>
            <span class="total-amount">${{ order.total }}</span>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn-approve">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          Approve Order
        </button>
        <button class="btn-reject">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
          Reject Order
        </button>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="page-container">
  <div class="header-section">
    <h2>Order Summary</h2>
    <div>
      <button class="btn btn-primary" (click)="addOrder()">Add Order</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="summary-table">
      <thead>
        <tr>
          <th style="width: 25%">Name</th>
          <th style="width: 20%">Email</th>
          <th style="width: 15%">Address</th>
          <th style="width: 10%">Date</th>
          <th style="width: 10%">Items</th>
          <th style="width: 10%">Total</th>
          <th style="width: 10%">Status</th>
          <th style="width: 5%">View</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of orders">
          <td>
            <div class="user-profile">
              <div class="user-details">
                <span class="name">{{ order.customerName }}</span>
                <span class="phone">+91 {{ order.phone }}</span>
              </div>
            </div>
          </td>

          <td class="text-grey">{{ order.email }}</td>

          <td class="text-grey">{{ order.address }}</td>

          <td class="text-grey">{{ order.date | date : "dd/MM/yyyy" }}</td>

          <td>
            <span class="item-count">{{ order.items.length }} Items</span>
          </td>

          <td class="total-price">₹ {{ order.total }}</td>

          <td>
            <span class="status-badge" [ngClass]="order.status | lowercase">
              {{ order.status }}
            </span>
          </td>

          <td></td>

          <td>
            <div [innerHtml]="SVG_ICONS.EYE_ICON() | sanitizer : 'html'" class="cursor-pointer" (click)="viewOrder()"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->

<div class="row mb-4">
  <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
    Orders List
    <div class="border-green-bottom"></div>
  </div>
  <!-- <div class="col-md-6 col-12 mt-2 d-flex justify-content-md-end">
    <div class="search-area">
      <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
      <input type="text" class="search-input" placeholder="Search Order" />
    </div>
  </div> -->
  <div align="end" class="mt-2 mb-2">
    <button class="add-btn me-2 px-4 py-2" (click)="addOrder()">Add Order</button>
  </div>
  <div class="table-responsive-scroll">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="w-100" matSort>
        <ng-container matColumnDef="TrainerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">TrainerName</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <!-- <div>{{ item.Trainer?.TrainerName }} {{ item.Trainer?.TrainerLastName }}</div>
            <div>+91 {{ item.Trainer?.MobileNumber }}</div> -->
            <div class="d-flex flex-column">
              <div class="fw-bold fs-14 font-white">{{ item.Trainer?.TrainerName }} {{ item.Trainer?.TrainerLastName }}</div>
              <div class="fw-normal fs-12 font-gray-opacity">
                <a href="tel: +91 {{ item.Trainer?.MobileNumber }}" class="font-white fs-12 fw-normal text-decoration-none">+91 {{ item.Trainer?.MobileNumber }}</a>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="CenterName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">CenterName</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Center?.CenterName }}</td>
        </ng-container>

        <ng-container matColumnDef="CreatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Order Date</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.CreatedDate | date : "dd/MM/yyyy" }}</td>
        </ng-container>

        <ng-container matColumnDef="Quantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Quantity</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Quantity }}</td>
        </ng-container>

        <ng-container matColumnDef="TotalAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">TotalAmount</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.TotalAmount }}</td>
        </ng-container>

        <!-- <ng-container matColumnDef="OrderStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Order Status</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.OrderStatus }}</td>
        </ng-container> -->
        <!-- 
        <ng-container matColumnDef="Edit">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Edit</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div [innerHtml]="SVG_ICONS.EDIT_PENCIL() | sanitizer : 'html'" role="button" (click)="viewOrder(item.OrderID)"></div>
          </td>
        </ng-container> -->

        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef class="font-gray">View</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div [innerHtml]="SVG_ICONS.EYE_ICON() | sanitizer : 'html'" role="button" (click)="viewOrder(item.OrderID)"></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      @if(dataSource.data.length === 0){
      <div class="text-center font-red-light fs-20 mt-2">No Data Found</div>
      }

      <mat-paginator [pageSizeOptions]="[10, 20]" [length]="length" showFirstLastButtons class="mt-3"></mat-paginator>
    </div>
  </div>
</div>
